import 'ant-design-vue/lib/style/index.less' // antd core styles
import './components/kit/vendors/antd/themes/default.less' // default theme antd components
import './components/kit/vendors/antd/themes/dark.less' // dark theme antd components
import './global.scss' // app & third-party component styles
import Vue from 'vue'
import VuePageTitle from 'vue-page-title'
import NProgress from 'vue-nprogress'
import VueLayers from 'vuelayers'
import 'vuelayers/dist/vuelayers.css' // needs css-loader
import 'vuelayers/src/styles/main.scss' //
import 'vue-select/dist/vue-select.css'
import BootstrapVue from 'bootstrap-vue'
import VueTippy, { TippyComponent } from 'vue-tippy'
import 'tippy.js/themes/light.css'
import 'tippy.js/themes/light-border.css'

import App from './App.vue'
import router from './router'
import Mapbox from 'mapbox-gl'
import * as VueMapbox from 'vue-mapbox'
import VueFormulate from '@braid/vue-formulate'
import FormulateVSelectPlugin from '@cone2875/vue-formulate-select'
import NfDatePicker from '@/components/NfDatePicker'
import NfTimePicker from '@/components/NfTimePicker'
import store from './store'
import { i18n } from './localization'
import './antd'
import { createPinia, PiniaVuePlugin } from 'pinia'
import AsyncComputed from 'vue-async-computed'
import Print from 'vue-print-nb'

Vue.use(Print)
Vue.use(BootstrapVue)
Vue.use(Mapbox)
Vue.use(VueMapbox)
// all input/output coordinates, GeoJSON features in EPSG:4326 projection
Vue.use(VueLayers, {
  dataProjection: 'EPSG:4326',
})
Vue.use(NProgress)
Vue.component('NfDatePicker', NfDatePicker)
Vue.component('NfTimePicker', NfTimePicker)
Vue.use(VueFormulate, {
  plugins: [FormulateVSelectPlugin],
  // Typeable date/time fields. Use over native type="date"/"time": Chrome's
  // picker popup swallows typed digits, and dates commit 2-digit years
  // literally (year 0027).
  library: {
    nfdate: { classification: 'text', component: 'NfDatePicker' },
    nftime: { classification: 'text', component: 'NfTimePicker' },
  },
})
Vue.use(VuePageTitle, {
  prefix: 'Routr | ',
  router,
})
Vue.use(PiniaVuePlugin)
const pinia = createPinia()

Vue.use(AsyncComputed)

Vue.use(VueTippy, {
  directive: 'tippy', // => v-tippy
  flipDuration: 0,
  popperOptions: {
    modifiers: {
      preventOverflow: {
        enabled: false,
      },
    },
  },
})

Vue.component('tippy', TippyComponent)

Vue.config.productionTip = false
const nprogress = new NProgress({ parent: 'body' })
const eventBus = new Vue()

export default eventBus

Vue.prototype.$eventBus = eventBus

// gloval directive
Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
})

// App-wide: clicking anywhere in a native date/time input opens its picker, not
// just the calendar/clock icon. showPicker() must run inside a user gesture
// (this click) and is feature-guarded, so unsupported browsers fall back to the
// icon. try/catch swallows the "already showing" error on double events.
document.addEventListener('click', (event) => {
  const el = event.target
  if (
    !el ||
    el.tagName !== 'INPUT' ||
    el.disabled ||
    el.readOnly ||
    typeof el.showPicker !== 'function'
  ) {
    return
  }
  if (!['date', 'time', 'datetime-local', 'month', 'week'].includes(el.type)) {
    return
  }
  try {
    el.showPicker()
  } catch (_) {
    // not supported / already showing - ignore
  }
})

new Vue({
  router,
  store,
  nprogress,
  i18n,
  pinia,
  render: (h) => h(App),
}).$mount('#app')
